import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../../Components/Layout/Footer';
import Navbar from '../../Components/Layout/Navbar';
import Sidebar from '../../Components/Layout/Sidebar';


const LayoutPage = () => {
  return (
    <div className='wrapper'>
      <Navbar />
      <Sidebar />
      <div id="main-content">
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

export default LayoutPage;